<template>
  <div class="mg-report-details-list mb-3">
    <div class="font-weight-bold mr-1">Contact:</div>
    <div v-if="contactInformation.fn">{{ contactInformation.fn }}</div>
    <div v-if="contactInformation.hasEmail">
      <a
        :href="'mailto:' + contactInformation.hasEmail"
        @click="
          trackMatomoEvent({
            category: 'Contact',
            action: 'Email Link Click',
            name: contactInformation.hasEmail,
          })
        "
      >
        <i class="fa fa-fw fa-paper-plane" aria-hidden="true" />
        <span class="mg-icon-text">{{ uiText["email"] }}</span>
      </a>
    </div>
    <div v-if="contactInformation.hasURL">
      <a :href="contactInformation.hasURL" target="_blank" rel="noopener noreferrer">
        <i class="fa fa-fw fa-globe" aria-hidden="true" />
        <span class="mg-icon-text">{{ contactInformation.hasURL }}</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSettingsStore } from "../../stores/settingsStore";
import { IPersons } from "../../interfaces/directory";
import trackMatomoEvent from "../../functions/trackMatomoEvent";

const settingsStore = useSettingsStore();

const { contactInformation } = defineProps<{
  contactInformation: IPersons;
}>();

const uiText = computed(() => settingsStore.uiText);
</script>
